import { render, staticRenderFns } from "./CamaraVODVerDetalle.vue?vue&type=template&id=47a45efe&"
import script from "./CamaraVODVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./CamaraVODVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraVODVerDetalle.vue?vue&type=style&index=0&acoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('47a45efe', component.options)
    } else {
      api.reload('47a45efe', component.options)
    }
    module.hot.accept("./CamaraVODVerDetalle.vue?vue&type=template&id=47a45efe&", function () {
      api.rerender('47a45efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/VOD/CamaraVODVerDetalle.vue"
export default component.exports